<template>
   <v-dialog
   v-model="openDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="title-card">
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.obra.id"
                :items="getObras"
                :rules="nameRules"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-select>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.pessoa.id"
                :items="getPessoas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Responsável"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.equipamento.id"
                :items="equipamentosConstrucao"
                :item-text="'descricao'"
                :item-value="'id'"
                outlined
                label="Equipamento"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                required
                :rules="nameRules"
                label="Descrição"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.quantidade"
                required
                type="number"
                :rules="nameRules"
                label="Quantidade"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.data_liberacao"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de liberação"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          dark
          :loading="loading"
          color="primary"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import equipamentosConstrucao from '../../../../utils/materiais';
import {
  currencyRules,
} from '@/validations';
export default {
  props:{
    openDialog: Boolean
  },
  data () {
      return {
      equipamentosConstrucao,
      currencyRules,  
      valid:false,
      formTitle:'Novo cadastro',
      nameRules: [
        v => !!v || 'Campo requerido',
      ],
      dialog: false,
      loading:false,
      obj: {
        obra: {
          id: null
        },
        pessoa: {
          id: null
        },
        equipamento: {
          id: null
        },
        descricao: '',
        nome:'',
        data_liberacao:''
      },
      moneyOptions: {
        precision: 2,
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        allowNegative: false,
        defaultValue: '0'
      }
      }
    },
    computed:{
      ...mapGetters('pessoa', {getPessoas:'getList'}),
      ...mapGetters('obra', {getObras:'getList'}),
      customObj(){
        return {
          ...this.obj,
          obra: {
            ...this.getObras.find((item) => item.id === this.obj.obra.id)
          },
          descricao: this.obj.descricao,
          data_liberacao_timestamp: this.formatToDatastamp(this.obj.data_liberacao)
        }
      }
    },
    methods: {
    ...mapActions('material', ['saveMaterial']),
    parseDateFromDDMMYYYY(dateString) {
      const [day, month, year] = dateString.split('/').map(Number);
      return new Date(year, month - 1, day); // Months are zero-indexed
    },
    formatDateToDDMMYYYY(date) {
      const day = String(date.getDate()).padStart(2, '0'); // Ensure day is always 2 digits
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed (0 = January)
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    getSameDayAfterMonths(date, monthsToAdd) {
      const newDate = new Date(date);
      
      // Set the month to the new month based on the parameter
      newDate.setMonth(date.getMonth() + monthsToAdd);
      
      // Handle edge cases where the new month has fewer days
      if (newDate.getDate() !== date.getDate()) {
        newDate.setDate(0); // Set to the last day of the previous month
      }

      return newDate;
    },
    formatToDatastamp(dateStr){
            // Split the date string into parts
      const [day, month, year] = dateStr.split('/').map(Number);

      // Create a new Date object
      const dateObj = new Date(year, month - 1, day); // month - 1 because JavaScript months are 0-indexed

      // Convert to timestamp (milliseconds since Unix epoch)
      const timestamp = dateObj.getTime();
      return timestamp;
    },
    async save() {
        this.$refs.form.validate()
        /* eslint-disable no-console */
        if (this.valid) {
            try {
              const data_liberacao = this.parseDateFromDDMMYYYY(this.obj.data_liberacao);
              const data_liberacao_timestamp = data_liberacao.getTime();
              const payload = {
                ...this.customObj,
                pessoa: {
                  ...this.getPessoas.find((item) => item.id === this.obj.pessoa.id)
                },
                obra: {
                  ...this.getObras.find((item) => item.id === this.obj.obra.id)
                },
                data_liberacao: this.formatDateToDDMMYYYY(data_liberacao),
                data_liberacao_timestamp
              };
              await this.saveMaterial(payload);
            } catch (error) {
                console.error(error);
            } finally {
              this.closeModal();
              this.$emit('searchByFilter')
            }
          }
      },
      closeModal () {
          this.$emit('closeModal')
      },
      reset(){
          this.$refs.form.reset()
      },
    watch:{
      openDialog(){
          this.reset();
      }
    }
  }
}
</script>
<style>
.v-main {
  width: 95% !important;
}
.menu {
  width: 100% !important;
  padding-top: 0px !important;
  z-index: 1;
  margin-top: 0px !important;
  position: inherit !important;
}
.btn-new{
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #0030b1 !important;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
</style>